// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".about-footer-flex-container[data-v-59b91ef3]{display:flex;background-color:#f8f7fb}.about-footer-content[data-v-59b91ef3]{margin:4rem auto 5rem;text-align:center;font-size:1.8rem;line-height:1.7;color:#67748c}.about-footer-link[data-v-59b91ef3]{min-width:25rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
